import type { Directive } from "vue";

/** Selecciona todo o conteúdo do campo ao ganhar foco, para que digitar um
 * novo valor substitua o actual (ex.: "0") em vez de ser necessário apagá-lo
 * primeiro. Usar em inputs de valor: `v-selecionar-ao-focar`. */
export const vSelecionarAoFocar: Directive<HTMLInputElement, unknown> = {
  mounted(el) {
    el.addEventListener("focus", () => el.select());
  },
};
